import {
  BoatCoverageProduct,
  CabinCoverageProduct,
  CaravanCoverageProduct,
  CarCoverageProduct,
  HouseCoverageProduct,
  MotorcycleCoverageProduct,
} from 'Types/coverages/coverages.types';

export const BOAT_COVERAGES: BoatCoverageProduct[] = [
  BoatCoverageProduct.BOAT_INBOARD_MOTOR_FULL_OWN_DAMAGE,
  BoatCoverageProduct.BOAT_INBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverageProduct.BOAT_JETSKI_FULL_OWN_DAMAGE,
  BoatCoverageProduct.BOAT_MOTOR_FULL_OWN_DAMAGE,
  BoatCoverageProduct.BOAT_MOTOR_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverageProduct.BOAT_OUTBOARD_MOTOR_FULL_OWN_DAMAGE,
  BoatCoverageProduct.BOAT_OUTBOARD_MOTOR_FULL_OWN_DAMAGE_EXTENDED,
  BoatCoverageProduct.BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE,
  BoatCoverageProduct.BOAT_SAILING_BOAT_FULL_OWN_DAMAGE,
  BoatCoverageProduct.BOAT_SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED,
];

export const CABIN_COVERAGES: CabinCoverageProduct[] = [
  CabinCoverageProduct.CABIN_EXTENDED_RENTAL,
  CabinCoverageProduct.CABIN_EXTENDED_WITH_CRAWLSPACE_RENTAL,
  CabinCoverageProduct.CABIN_EXTENDED_WITH_CRAWLSPACE,
  CabinCoverageProduct.CABIN_EXTENDED_WITHOUT_CRAWLSPACE_RENTAL,
  CabinCoverageProduct.CABIN_EXTENDED,
  CabinCoverageProduct.CABIN_OTHER_BUILDINGS_EXTENDED,
  CabinCoverageProduct.CABIN_OTHER_BUILDINGS_STANDARD,
  CabinCoverageProduct.CABIN_STANDARD,
];

export const CAR_COVERAGES: CarCoverageProduct[] = [
  CarCoverageProduct.CAR_FULL_OWN_DAMAGE_INCLUDING_RENTALCAR,
  CarCoverageProduct.CAR_FULL_OWN_DAMAGE,
];

export const CARAVAN_COVERAGES: CaravanCoverageProduct[] = [
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1,
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1,
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_2,
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_3,
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_1,
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_2,
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_3,
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE,
  CaravanCoverageProduct.CARAVAN_FULL_OWN_DAMAGE,
];

export const HOUSE_COVERAGES: HouseCoverageProduct[] = [
  HouseCoverageProduct.HOUSE_EXTENDED_WITH_CRAWL_SPACE,
  HouseCoverageProduct.HOUSE_EXTENDED,
  HouseCoverageProduct.HOUSE_OTHER_BUILDINGS_EXTENDED,
  HouseCoverageProduct.HOUSE_OTHER_BUILDINGS_STANDARD,
  HouseCoverageProduct.HOUSE_STANDARD_WITH_PARTIALLY_RENTAL,
  HouseCoverageProduct.HOUSE_STANDARD_WITH_RENTAL,
  HouseCoverageProduct.HOUSE_STANDARD,
];

export const MOTORCYCLE_COVERAGES: MotorcycleCoverageProduct[] = [
  MotorcycleCoverageProduct.MOTORCYCLE_FULL_OWN_DAMAGE,
];
